var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary--text text-uppercase font-weight-medium font-italic",class:{
    'text-h4 text-sm-h3 text-lg-h2': !_vm.small,
    'text-h5 text-lg-h4': _vm.small,
  }},[_c('span',{staticClass:"font-secondary"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }